export default {
  header: {
    logo: 'Vuejs',
    home: 'Home',
    examples: 'Examples',
    documents: 'Documentation',
    blog: 'Blog',
    locale: 'Language(语言)',
    issues: 'Issues',
    github: 'Github',
  },

  locale: {
    en: 'English',
    'zh-cn': '中文(简体)',
  },

  document: {
    title: 'Documentation',
  },

  example: {
    full: 'Full Example',
    simple: 'Simple',
    avatar: 'Upload avatar',
    drag: 'Drag and drop',
    multiple: 'Multiple instances',
    chunk: 'Chunk upload',
    vuex: 'Vuex',
  }
}
